import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=4bcf24f8&scoped=true&"
import script from "./ProjectEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=4bcf24f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcf24f8",
  null
  
)

export default component.exports